require("./key-details.scss");